import React, { useRef } from 'react';
import { Link } from 'gatsby';

import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import classNames from 'classnames';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';

export default ({ description, image, spotlight }) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);

  return (
    <section
      ref={intersectionRef}
      className={classNames(
        'home-spotlight df x fdc fdr--md bb--dark-brown reveal',
        { revealed: isIntersected }
      )}
    >
      <aside className="home-spotlight__header-title pb2 pb5--md">
        <p className="serif--md serif--lg--lg p2 pt5--md">
          SPOTLIGHT by eugenie
        </p>
        {description && (
          <div className="rich-text pl2 pr5--lg">
            <BlockContent blocks={description} serializers={richText} />
          </div>
        )}
        <div className="title df aib bt--dark-brown--md p2 pt5--lg  mt7--md mt10--lg">
          <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
            Artist
          </p>
          <p className="serif--sm serif--md--md">{spotlight.artist}</p>
        </div>
        <div className="df aib p2">
          <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
            Dates
          </p>
          <p className="sans--sm ">{spotlight.dates}</p>
        </div>
        <div className="df aib p2">
          <p className="mono--sm mono--md--md mr1 uppercase spotlight-index__label">
            Spotlight
          </p>
          {spotlight.introText && (
            <div className="sans--sm rich-text pr5--lg">
              <BlockContent
                blocks={spotlight.introText}
                serializers={richText}
              />
            </div>
          )}
        </div>
        <Link
          className="sans--md link--underline ml2"
          to={`/spotlight/${spotlight.slug}`}
        >
          Read Story
        </Link>
      </aside>
      <aside className="home-spotlight__header-image">
        <div className="home-spotlight__header-image-wrapper">
          <picture className="">
            <source
              srcSet={`${image.url}?w=1400&auto=format&q=100`}
              media="(min-width: 1000px)"
            />
            <source
              srcSet={`${image.url}?w=1000&auto=format&q=100`}
              media="(min-width: 600px)"
            />
            <img
              alt={spotlight.artist}
              className="x db"
              src={`${image.url}?w=900&auto=format&q=100`}
            />
          </picture>
        </div>
      </aside>
    </section>
  );
};
